<template>
  <div class="polygon-drawer">
    <div style="height: 500px; width: 100%">
      <GmapMap
        :id="gmapId"
        ref="gmap"
        :center="center"
        :zoom="mapZoom"
        style="height: 100%; width: 100%"
        @tilesloaded="initDrawingManager"
        :options="mapOptions"
      >
      </GmapMap>
    </div>

    <div class="zone-controls mt-2">
      <input
        v-model="newZoneName"
        type="text"
        placeholder="Nombre de zona"
        class="zone-input"
      />
      <b-button
        variant="primary"
        @click="addZone"
        class="zone-button"
        :disabled="zones.length >= 10"
        :id="addZoneId"
      >
        Agregar Zona
      </b-button>
    </div>

    <ul class="zone-list mt-4" :id="zoneListId">
      <li
        v-for="zone in zones"
        :key="zone.id"
        @click="setActiveZone(zone.id)"
        class="zone-item"
        :style="{ borderColor: activeZone === zone.id ? zone.color : '#ccc' }"
      >
        <b-form-input
          v-model="zone.name"
          class="zone-name-input px-0 mx-0"
          @change="updateZoneName(zone.id, zone.name)"
        />
        <feather-icon
          size="16"
          icon="TrashIcon"
          class="delete-icon cursor-pointer mx-1"
          @click="deleteZone(zone.id)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
// Mixins
import messagesMixin from "@/@core/mixins/messagesMixin"

export default {
  components: {},
  mixins: [messagesMixin],
  props: {
    zoom: {
      type: Number,
      default: 13,
    },
    defaultZones: {
      type: Array,
      default: () => [],
    },
    latitude: {
      type: Number,
      default: 19.4326077,
    },
    longitude: {
      type: Number,
      default: -99.133208,
    },
    gmapId: {
      type: String,
      default: "gmap",
    },
    zoneListId: {
      type: String,
      default: "zone-list",
    },
    addZoneId: {
      type: String,
      default: "add-zone",
    },
  },
  data() {
    return {
      mapCenter: { lat: 19.4326, lng: -99.1332 },
      mapZoom: this.zoom,
      mapReady: false,
      zones: [],
      newZoneName: "Zona 1",
      isDrawing: false,
      drawingManager: null,
      center: { lat: this.latitude, lng: this.longitude },
      drawingManager: null,
      activeZone: null,
      pendingDefaultZones: null,
      mapOptions: {
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: false,
        restriction: {
          latLngBounds: {
            north: 32.718,
            south: 14.532,
            west: -118.503,
            east: -86.589,
          },
          strictBounds: false,
        },
      },
    }
  },
  watch: {
    defaultZones: {
      immediate: true,
      handler(newZones) {
        if (newZones && newZones.length > 0) {
          if (this.mapReady) {
            this.loadDefaultZones(newZones)
          } else {
            this.pendingDefaultZones = newZones
          }
        }
      },
    },
    latitude: {
      immediate: true,
      handler(newLat) {
        this.center = this.getBoundedLatLng(newLat, this.longitude)
        this.marker = this.center
      },
    },
    longitude: {
      immediate: true,
      handler(newLng) {
        this.center = this.getBoundedLatLng(this.latitude, newLng)
        this.marker = this.center
      },
    },
    zones: {
      immediate: true,
      handler(newZones) {
        if (!newZones || !this.drawingManager) return
        if (newZones.length >= 10) {
          this.drawingManager.setDrawingMode(null)
          this.warnToast({
            title: "Se ha alcanzado el maximo de zonas",
            text: "Si deseas agregar mas zonas, por favor, elimina una de las existentes",
          })
          return
        }
      },
    },
  },
  methods: {
    addZone() {
      this.drawingManager.setDrawingMode(
        window.google.maps.drawing.OverlayType.POLYGON
      )
    },
    calculateCentroid(coordinates) {
      let x = 0,
        y = 0,
        n = coordinates.length
      coordinates.forEach((coord) => {
        x += coord.lat
        y += coord.lng
      })
      return { lat: x / n, lng: y / n }
    },
    updateZoneLabel(zone) {
      const google = window.google
      const map = this.$refs.gmap.$mapObject

      const centroid = this.calculateCentroid(zone.coordinates)

      if (zone.marker) {
        zone.marker.setMap(null)
      }

      // if (zone.infoWindow) {
      //   zone.infoWindow.setMap(null)
      // }

      // zone.infoWindow = new google.maps.InfoWindow({
      //   content: `<div style="font-weight: bold; color: black; background: white; padding: 5px; border-radius: 3px;">${zone.name}</div>`,
      //   position: centroid,
      //   pixelOffset: new google.maps.Size(0, -10),
      // })

      // zone.infoWindow.open(map)

      zone.marker = new google.maps.Marker({
        position: centroid,
        map: map,
        label: {
          text: zone.name,
          color: "black",
          fontWeight: "bold",
          fontSize: "14px",
        },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 0,
        },
      })
    },
    getBoundedLatLng(lat, lng) {
      const bounds = {
        north: 32.718,
        south: 14.532,
        west: -118.503,
        east: -86.589,
      }

      return {
        lat: Math.max(bounds.south, Math.min(bounds.north, lat)),
        lng: Math.max(bounds.west, Math.min(bounds.east, lng)),
      }
    },
    getUniqueColor() {
      var letters = "0123456789ABCDEF"
      var color = "#"
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    loadDefaultZones(zones) {
      const google = window.google
      const map = this.$refs.gmap.$mapObject

      if (!map) {
        console.error("Map is not ready for loading default zones")
        this.pendingDefaultZones = zones
        return
      }

      zones.forEach((zone) => {
        if (this.zones.some((z) => z.name === zone.name)) return

        const color = this.getUniqueColor()
        const polygon = new google.maps.Polygon({
          paths: zone.coordinates,
          fillColor: color,
          fillOpacity: 0.4,
          strokeColor: color,
          strokeWeight: 2,
          editable: false,
          map: map,
        })

        const zoneId = Date.now().toString() + Math.random() // ID único
        polygon.set("zoneId", zoneId)

        const newZone = {
          id: zoneId,
          name: zone.name,
          coordinates: zone.coordinates,
          overlay: polygon,
          color,
        }

        this.zones.push(newZone)
        this.addPolygonListeners(newZone)
        this.updateZoneLabel(newZone)
      })

      this.$emit("zones", this.zones)
    },
    updateZoneCoordinates(zoneId) {
      const zone = this.zones.find((z) => z.id === zoneId)
      if (zone) {
        const path = zone.overlay.getPath()
        const coordinates = []
        for (let i = 0; i < path.getLength(); i++) {
          const point = path.getAt(i)
          coordinates.push({ lat: point.lat(), lng: point.lng() })
        }
        zone.coordinates = coordinates
        this.updateZoneLabel(zone)
        this.$emit("zones", this.zones)
      }
    },
    addPolygonListeners(zone) {
      const google = window.google
      const path = zone.overlay.getPath()

      google.maps.event.addListener(path, "set_at", () => {
        this.updateZoneCoordinates(zone.id)
      })
      google.maps.event.addListener(path, "insert_at", () => {
        this.updateZoneCoordinates(zone.id)
      })
      google.maps.event.addListener(path, "remove_at", () => {
        this.updateZoneCoordinates(zone.id)
      })
    },
    initDrawingManager() {
      if (this.drawingManager) return

      const google = window.google
      const map = this.$refs.gmap.$mapObject

      this.drawingManager = new google.maps.drawing.DrawingManager({
        drawingControl: false,
        polygonOptions: {
          fillOpacity: 0.4,
          strokeWeight: 2,
          editable: true,
        },
      })

      this.drawingManager.setMap(map)

      google.maps.event.addListener(
        this.drawingManager,
        "overlaycomplete",
        (event) => {
          if (event.type === "polygon") {
            const path = event.overlay.getPath()
            const coordinates = []
            for (let i = 0; i < path.getLength(); i++) {
              const point = path.getAt(i)
              coordinates.push({ lat: point.lat(), lng: point.lng() })
            }

            const color = this.getUniqueColor()
            event.overlay.setOptions({
              fillColor: color,
              strokeColor: color,
              fillOpacity: 0.4,
              strokeWeight: 2,
            })
            const zoneId = Date.now().toString()
            event.overlay.set("zoneId", zoneId)

            const zone = {
              id: zoneId,
              name: this.newZoneName.trim() || `Zona ${this.zones.length + 1}`,
              coordinates,
              overlay: event.overlay,
              color,
            }

            this.zones.push(zone)
            this.addPolygonListeners(zone)
            this.updateZoneLabel(zone)

            this.$emit("zones", this.zones)

            this.newZoneName = `Zona ${this.zones.length + 1}`
            this.drawingManager.setDrawingMode(null)
          }
        }
      )

      this.mapReady = true
      if (this.pendingDefaultZones) {
        this.loadDefaultZones(this.pendingDefaultZones)
        this.pendingDefaultZones = null
      }
    },

    setActiveZone(id) {
      this.activeZone = id
      this.zones.forEach((zone) => {
        zone.overlay.setEditable(zone.id === id)
      })
    },
    updateZoneName(id, name) {
      const zone = this.zones.find((z) => z.id === id)
      if (zone) {
        zone.name =
          name.trim() || `Zona ${this.zones.findIndex((z) => z.id === id) + 1}`
        this.updateZoneLabel(zone)
      }
    },
    deleteZone(id) {
      const index = this.zones.findIndex((z) => z.id === id)
      if (index !== -1) {
        const zone = this.zones[index]
        zone.overlay.setMap(null)

        if (zone.marker) {
          zone.marker.setMap(null)
        }
        this.zones.splice(index, 1)
        if (this.activeZone === id) this.activeZone = null
      }
    },
  },
}
</script>

<style></style>

<style scoped>
.polygon-drawer {
  display: flex;
  flex-direction: column;
}
.zone-controls {
  display: flex;
  gap: 8px;
}
.zone-input {
  flex: 1;
  padding: 6px;
}
.zone-add-btn {
  padding: 6px 12px;
  background-color: #2196f3;
  color: white;
  border: none;
  border-radius: 4px;
}
.zone-list {
  list-style: none;
  padding: 0;
}
.zone-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid #ccc;
  border-radius: 4px;
  padding: 6px;
  margin-bottom: 6px;
}
.zone-name-input {
  flex: 1;
  border: none;
  background: transparent;
}
.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
</style>
